export default "__VITE_ASSET__Cx$W4zF1__"